<script>
export default {
    name: 'IlluConversation',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7',
        },

        secondaryColor: {
            type: String,
            default: '#313132',
        },
    },
}
</script>
<template>
    <svg role="img"
        class="base-illu illu-conversation"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <path
                d="M13 9.5c-.966 0-1.841.392-2.475 1.025A3.489 3.489 0 009.5 13v35.254c0 .94.381 1.792.998 2.408a3.406 3.406 0 005.02-.221l5.7-6.806a4.5 4.5 0 013.45-1.611H51c.966 0 1.841-.392 2.475-1.025a3.489 3.489 0 001.025-2.475V13c0-.273-.024-.544-.248-.797-.212-.24-.57-.455-1.141-.668-1.166-.436-3.132-.815-6.43-1.129C40.728 9.84 30.513 9.5 13 9.5z"
                :stroke="secondaryColor"
                class="secondary-color"
            />
            <path
                d="M32 31v3H19v-3h13zm13-7v3H19v-3h26zm0-7v3H19v-3h26z"
                :fill="primaryColor"
                class="primary-color"
            />
        </g>
    </svg>
</template>
